import { render, staticRenderFns } from "./GaleriaImagemBannerComponent.vue?vue&type=template&id=44fcdb9a&scoped=true&"
import script from "./GaleriaImagemBannerComponent.vue?vue&type=script&lang=js&"
export * from "./GaleriaImagemBannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaImagemBannerComponent.vue?vue&type=style&index=0&id=44fcdb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcdb9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VFlex,VIcon,VImg,VLayout})
